"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformSearchStringToLocationRegex = void 0;
const legacy_utils_1 = require("@daytrip/legacy-utils");
function transformSearchStringToLocationRegex(searchString) {
    const sanitizedSearchString = (0, legacy_utils_1.sanitizeSearchString)(searchString);
    return new RegExp(`.*${sanitizedSearchString.replace(" ", ".*")}.*`);
}
exports.transformSearchStringToLocationRegex = transformSearchStringToLocationRegex;
//# sourceMappingURL=transformSearchStringToLocationRegex.js.map